import {FC} from 'react';
import {t} from 'i18next';
import {Box, Typography} from '@mui/material';
import './DiveDeeper.scss';
import ArrButton from '../../../../common/arr-button/ArrButton';

interface Prompt {
  id: number;
  question: string;
}

interface DiveDeeperProps {
  prompts: Prompt[];
  onSelectPrompt: (question: string) => void;
}
const DiveDeeper: FC<DiveDeeperProps> = ({prompts, onSelectPrompt}) => {
  return (
    <Box
      className="dive-deeper animate-in fade-in duration-500"
      data-testid="dive-deeper"
    >
      <Typography
        className="typo-text label2_size dive-deeper__title"
        data-testid="dive-deeper-title"
      >
        {t('ai.investigate.questionAndAnswerPanel.diveDeeperSection.title')}
      </Typography>
      <Box className="dive-deeper__buttons" data-testid="dive-deeper-buttons">
        {prompts.map((prompt) => (
          <ArrButton
            key={prompt.id}
            className="dive-deeper__button"
            dataTestId={`suggested-prompt-${prompt.id}`}
            aria-label={prompt.question}
            onClick={() => onSelectPrompt(prompt.question)}
          >
            {prompt.question}
          </ArrButton>
        ))}
      </Box>
    </Box>
  );
};
export default DiveDeeper;
